/**
 * useWorkOrderJobTypes Hook
 *
 * React Query hook for fetching job type options for the work orders filter.
 */

import { queryKeys } from '@/lib/query-client';
import { useQuery } from '@tanstack/react-query';
import { getJobCategories } from '../api/jobTypesApi';

/**
 * Fetch job types for the work orders job type filter dropdown
 */
export function useWorkOrderJobTypes() {
  const queryKey = queryKeys.jobs.jobTypes();

  const query = useQuery({
    queryKey,
    queryFn: () => getJobCategories(),
    staleTime: 5 * 60 * 1000, // 5 minutes - job types don't change often
    gcTime: 30 * 60 * 1000, // 30 minutes
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    status: query.status,
  };
}
